import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { interval, Subscription } from 'rxjs';
import { TraceLogService } from './trace-log.service';
import { apiData } from 'src/app/services/api-lookup';

const TRACE_LOG_APPEND_URL = apiData[346].TraceLogAppendUrl!; 

@Injectable({
  providedIn: 'root'
})
export class TraceLogFlushService {

  private requestSub: Subscription | null = null;
  private responseSub: Subscription | null = null;
  private readonly apiUrl = TRACE_LOG_APPEND_URL;

  constructor(
    private http: HttpClient,
    private traceLogService: TraceLogService
  ) {}

  start(): void {
    if (!this.isTokenActive()) {
      return;
    }

    if (!this.requestSub) {
      this.requestSub = interval(30000).subscribe(() => this.flushRequests());
    }
    if (!this.responseSub) {
      this.responseSub = interval(30000).subscribe(() => this.flushResponses());
    }
  }

  stop(): void {
    if (this.requestSub) {
      this.requestSub.unsubscribe();
      this.requestSub = null;
    }
    if (this.responseSub) {
      this.responseSub.unsubscribe();
      this.responseSub = null;
    }
  }

  flush(): void {
    if (!this.isTokenActive()) return;
    this.flushRequests();
    this.flushResponses();
  }

  flushRequests(): void {
    if (!this.isTokenActive()) return;
    if (!this.traceLogService.hasRequestLogs()) return;

    const entriesToSend = this.traceLogService.drainRequests();
    if (entriesToSend.length === 0) return;

    this.http.post(this.apiUrl, entriesToSend, { headers: this.buildHeaders() })
      .subscribe({
        next: () => {},
        error: () => {
          entriesToSend.forEach(entry => this.traceLogService.addRequest(entry));
        }
      });
  }

  flushResponses(): void {
    if (!this.isTokenActive()) return;
    if (!this.traceLogService.hasResponseLogs()) return;

    const entriesToSend = this.traceLogService.drainResponses();
    if (entriesToSend.length === 0) return;

    this.http.post(this.apiUrl, entriesToSend, { headers: this.buildHeaders() })
      .subscribe({
        next: () => {},
        error: () => {
          entriesToSend.forEach(entry => this.traceLogService.addResponse(entry));
        }
      });
  }

  private isTokenActive(): boolean {
    const token = sessionStorage.getItem('authToken');
    if (!token) return false;

    const parts = token.split('.');
    if (parts.length !== 3) return false;

    try {
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      if (!payload.exp) return false;
      return Date.now() < payload.exp * 1000;
    } catch {
      return false;
    }
  }

  private buildHeaders(): HttpHeaders {
    const token = sessionStorage.getItem('authToken');
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);

    const correlationId = sessionStorage.getItem('CorrelationId');
    if (correlationId) headers = headers.set('X-Correlation-Id', correlationId);

    return headers;
  }
}